import styled from "styled-components";
import { device } from "../../stylesheet/breakpoints";

type Props = {
  design_type?: number;
};

export const TextLabelBox = styled.p<Props>`
  /* margin-top: 10px; */
  font-weight: 600;
  font-size: 8px;
  line-height: 2;
  color: var(--text-color);

  @media ${device.desktop} {
    display: block;
    width: 160px;
    padding-top: 10px;
    padding-bottom: 10px;
    background-color: var(--bg-color);
    border-radius: 5px;
    text-align: start;

    ${({ design_type }) => {
      if (design_type === 1) {
        return `
        position: absolute;
        bottom: -16px;
        left: 20px;
        text-align: center;
    `;
      }
    }}
    ${({ design_type }) => {
      if (design_type === 2) {
        return `
        position: absolute;
        bottom: -16px;
        right: 20px;
        text-align: center;
    `;
      }
    }}
${({ design_type }) => {
      if (design_type === 3) {
        return `
        position: absolute;
        bottom: -16px;
        right: 20px;
        text-align: center;
    `;
      }
    }}
${({ design_type }) => {
      if (design_type === 4) {
        return `
        position: absolute;
        bottom: -16px;
        left: 20px;
        text-align: center;
    `;
      }
    }}
${({ design_type }) => {
      if (design_type === 5 || design_type === 6) {
        return `
        position: absolute;
        top: -16px;
        text-align: center;
    `;
      }
    }}
  }
`;

export const TextLabelSecond = styled.a`
  text-decoration: none;
  color: var(--bg-button);

  &:visited,
  &:hover,
  &:active,
  &:focus {
    color: var(--bg-button);
  }
`;
